// Sign in → pick a hero → play. Account and character screens are plain DOM over the canvas.
import Phaser from 'phaser';
import { HEROES } from '../../shared/heroes.ts';
import { Net } from './net.ts';
import { WorldScene } from './scene.ts';

const $ = <T extends HTMLElement>(id: string) => document.getElementById(id) as T;

async function api(path: string, body?: unknown): Promise<{ status: number; data: Record<string, unknown> }> {
  const res = await fetch(path, body === undefined ? {} : { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) });
  return { status: res.status, data: (await res.json().catch(() => ({}))) as Record<string, unknown> };
}

async function boot(): Promise<void> {
  const me = await api('/api/me');
  if (me.status === 401) return showAuth();
  if (!me.data.character) return showCreate();
  startGame();
}

function showAuth(): void {
  $('auth').classList.remove('hidden');
  let mode: 'login' | 'register' = 'login';
  const setMode = (m: typeof mode) => {
    mode = m;
    $('tab-login').classList.toggle('active', m === 'login');
    $('tab-register').classList.toggle('active', m === 'register');
    $('auth-submit').textContent = m === 'login' ? 'Sign in' : 'Make account';
    $<HTMLInputElement>('auth-pass').autocomplete = m === 'login' ? 'current-password' : 'new-password';
  };
  $('tab-login').onclick = () => setMode('login');
  $('tab-register').onclick = () => setMode('register');
  $<HTMLFormElement>('auth-form').onsubmit = async (e) => {
    e.preventDefault();
    const r = await api(`/api/${mode}`, { username: $<HTMLInputElement>('auth-user').value, password: $<HTMLInputElement>('auth-pass').value });
    if (r.status !== 200) {
      $('auth-error').textContent = String(r.data.error ?? 'That did not work.');
      return;
    }
    $('auth').classList.add('hidden');
    boot();
  };
}

function showCreate(): void {
  $('create').classList.remove('hidden');
  let picked = HEROES[0].slug;
  const grid = $('heroes');
  grid.innerHTML = '';
  for (const h of HEROES) {
    const el = document.createElement('div');
    el.className = 'hero' + (h.slug === picked ? ' picked' : '');
    // Column 0 of the sheet is the standing pose; row 2 faces the camera (south).
    el.innerHTML = `<div class="face" style="background-image:url(/art/char-${h.slug}.png);background-position:-8px -${2 * 128 + 8}px"></div>${h.name}`;
    el.onclick = () => {
      picked = h.slug;
      grid.querySelectorAll('.hero').forEach((n) => n.classList.remove('picked'));
      el.classList.add('picked');
    };
    grid.appendChild(el);
  }
  $<HTMLFormElement>('create-form').onsubmit = async (e) => {
    e.preventDefault();
    const r = await api('/api/character', { name: $<HTMLInputElement>('create-name').value, hero: picked });
    if (r.status !== 200) {
      $('create-error').textContent = String(r.data.error ?? 'That did not work.');
      return;
    }
    $('create').classList.add('hidden');
    startGame();
  };
}

function startGame(): void {
  const net = new Net();
  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'game',
    scale: { mode: Phaser.Scale.RESIZE, width: window.innerWidth, height: window.innerHeight },
    backgroundColor: '#0d0f0c',
    pixelArt: false,
    roundPixels: true,
    disableContextMenu: true,
    scene: [],
  });
  game.scene.add('world', WorldScene, true, { net });
  $('hud').classList.remove('hidden');
}

// Right-click is a game action (place, eat, open). A chest panel can open under the cursor
// before the browser's contextmenu event fires, so block the menu page-wide, not just on the canvas.
document.addEventListener('contextmenu', (e) => {
  if ((e.target as HTMLElement).tagName !== 'INPUT') e.preventDefault();
});

boot();
